import React from 'react';

const HeroSection2: React.FC = () => {
  return (
    <section className="bg-white px-4">
      <div className="mx-auto px-4 md:px-10 lg:px-32 w-full">
        {/* Main Headline */}
        <div className="lg:text-center">
          <h1 className="font-bold lg:text-[42px] md:text-[32px] text-[28px] leading-[100%] text-[#192842] tracking-[1%] mb-1">
          Rob Is Ready to Share his Proven Method of
          </h1>
          <h1 className="font-bold lg:text-[42px] md:text-[32px] text-[28px] leading-[100%] text-[#192842] tracking-[1%]">
            Picking Mining Juniors 
          </h1>
        </div>
        
        {/* Body Text */}
        <div className="max-w-[970px] mx-auto text-justify space-y-6 mb-12 mt-10" style={{ hyphens: 'auto', textAlign: 'justify', textJustify: 'inter-word' }}>
          <p className="lg:text-[22px] md:text-[18px] text-[16px] font-[400] text-[#192842] lg:leading-[32px] md:leading-[26px] leading-[23px]">
          Rob's success relies on his rock-solid method of selecting the best junior mining companies.          </p>
          
          <p className="lg:text-[22px] md:text-[18px] text-[16px] font-[400] text-[#192842] lg:leading-[32px] md:leading-[26px] leading-[23px]">
          It has two elements: <span className='font-bold'>life-changing upside potential and limited risk.         </span> </p>
          
          <p className="lg:text-[22px] md:text-[18px] text-[16px] font-[400] text-[#192842] lg:leading-[32px] md:leading-[26px] leading-[23px]">
          On the upside, Rob is looking for stocks that can soar 10x.          </p>
          
          <p className="lg:text-[22px] md:text-[18px] text-[16px] font-[400] text-[#192842] lg:leading-[32px] md:leading-[26px] leading-[23px]">
          Not every junior mining company has it… yet many management teams will tell you they do.          </p>
          
          <p className="lg:text-[22px] md:text-[18px] text-[16px] font-[400] text-[#192842] lg:leading-[32px] md:leading-[26px] leading-[23px]">
          Rob is here to sift through their news releases to bring you the ideas that can, potentially, return 1000% or more.          </p>
          
          <p className="lg:text-[22px] md:text-[18px] text-[16px] font-[400] text-[#192842] lg:leading-[32px] md:leading-[26px] leading-[23px]">
          In the mining industry, companies live and die by the quality of their drill results.          </p>
          
          <p className="lg:text-[22px] md:text-[18px] text-[16px] font-[400] text-[#192842] lg:leading-[32px] md:leading-[26px] leading-[23px]">
          They raise money, explore, and report what they find (or not).         
           </p>
          <p className="lg:text-[22px] md:text-[18px] text-[16px] font-[400] text-[#192842] lg:leading-[32px] md:leading-[26px] leading-[23px]">
          A lot of companies engage in technical chicanery that can make their exploration results
          sound better than they actually are.           </p>
          <p className="lg:text-[22px] md:text-[18px] text-[16px] font-[400] text-[#192842] lg:leading-[32px] md:leading-[26px] leading-[23px]">
          Rob can identify the companies that make honest progress and deliver excellent work.           </p>
          <p className="lg:text-[22px] md:text-[18px] text-[16px] font-[400] text-[#192842] lg:leading-[32px] md:leading-[26px] leading-[23px]">
          Those that make a genuine discovery are the ones that have 10x potential           </p>
          <p className="lg:text-[22px] md:text-[18px] text-[16px] font-[400] text-[#192842] lg:leading-[32px] md:leading-[26px] leading-[23px]">
          Now, the mining industry is quite technical. And some unscrupulous companies try their
          hardest to make themselves look as good as possible—with no actual progress to show.           </p>
          <p className="lg:text-[22px] md:text-[18px] text-[16px] font-[400] text-[#192842] lg:leading-[32px] md:leading-[26px] leading-[23px]">
          Rob has the right experience and the track record to spot the companies that try to
make investors excited… and the ones that can really deliver life-changing returns.
       
           </p>
          <p className="lg:text-[22px] md:text-[18px] text-[16px] font-[400] text-[#192842] lg:leading-[32px] md:leading-[26px] leading-[23px]">
          He looks through their drill results… he evaluates how rich and realistic they are… what
          economic value they create… and how they can reward their shareholders.
                     </p>
          <p className="lg:text-[22px] md:text-[18px] text-[16px] font-[400] text-[#192842] lg:leading-[32px] md:leading-[26px] leading-[23px]">
          Rob knows how to separate genuine discoveries from fantasy.
          In other words, he knows the game.
                     </p>
          <p className="lg:text-[22px] md:text-[18px] text-[16px] font-[400] text-[#192842] lg:leading-[32px] md:leading-[26px] leading-[23px]">
          He has the technical knowledge and the market awareness to filter out the wannabes
and focus on the real deals.
                     </p>
        </div>
        
      </div>
    </section>
  );
};

export default HeroSection2;
